import { useEffect, useMemo, useState } from 'react';

import { Fristen } from './bereiche/Fristen';
import { Glossar } from './bereiche/Glossar';
import { Jahresfahrplan } from './bereiche/Jahresfahrplan';
import { useInhalte } from './directus/useInhalte';
import { Kopfzeile } from './komponenten/Kopfzeile';
import { TabLeiste } from './komponenten/TabLeiste';
import type { TabId } from './komponenten/TabLeiste';
import {
  KonfigurationFehlt,
  LadeAnzeige,
  VerbindungFehlt,
} from './komponenten/Zustaende';
import { konfigurationFehlt } from './konfiguration';
import { monatsLuecken, phaseAm } from './logik/schuljahr';

export default function App() {
  // Einmal beim Start festhalten. Ein neues Date() bei jedem Rendern wuerde
  // die Ampel mitten in der Benutzung springen lassen und jede Memoisierung
  // wertlos machen.
  const heute = useMemo(() => new Date(), []);

  const { zustand, erneutLaden } = useInhalte();
  const [tab, setTab] = useState<TabId>('fristen');

  const fehlendeKonfiguration = konfigurationFehlt();

  const phaseJetzt = useMemo(() => {
    if (zustand.status !== 'fertig') return null;
    return phaseAm(heute, zustand.inhalte.phasen);
  }, [zustand, heute]);

  // Luecken in der Monatszuordnung sind ein Pflegefehler in Directus. Sie
  // gehoeren in die Konsole, nicht in die Oberflaeche: Eine Lehrkraft kann
  // daran nichts aendern.
  useEffect(() => {
    if (zustand.status !== 'fertig') return;
    const fehlend = monatsLuecken(zustand.inhalte.phasen);
    if (fehlend.length > 0) {
      console.warn(
        `[Phasen] Diese Monate gehoeren zu keiner Phase: ${fehlend.join(', ')}. ` +
          'In Directus unter "Phasen" ergaenzen.',
      );
    }
  }, [zustand]);

  if (fehlendeKonfiguration !== null) {
    return <KonfigurationFehlt grund={fehlendeKonfiguration} />;
  }

  return (
    <div className="min-h-screen bg-marke-flaeche">
      <Kopfzeile tab={tab} phase={phaseJetzt} />

      <main className="mx-auto max-w-5xl px-5 pb-28">
        {zustand.status === 'laedt' && <LadeAnzeige />}

        {zustand.status === 'fehler' && (
          <VerbindungFehlt
            art={zustand.art}
            technisch={zustand.technisch}
            erneutLaden={erneutLaden}
          />
        )}

        {zustand.status === 'fertig' && (
          <>
            {tab === 'fristen' && (
              <Fristen inhalte={zustand.inhalte} phaseJetzt={phaseJetzt} heute={heute} />
            )}
            {tab === 'jahresplan' && (
              <Jahresfahrplan inhalte={zustand.inhalte} phaseJetzt={phaseJetzt} />
            )}
            {tab === 'glossar' && <Glossar inhalte={zustand.inhalte} />}
          </>
        )}
      </main>

      <TabLeiste aktiv={tab} wechsle={setTab} />
    </div>
  );
}
